import { Config } from '@/types/Config'

export default {
  apiUrl: process.env.VUE_APP_CONFIG_API_URL,
  paymentsUrl: process.env.VUE_APP_CONFIG_PAYMENTS_URL,
  googleReservationsPartnerId: process.env.VUE_APP_CONFIG_GOOGLE_RESERVATIONS_PARTNER_ID,
  googleReservationsConversionEndpoint: process.env.VUE_APP_CONFIG_GOOGLE_RESERVATIONS_CONVERSION_ENDPOINT
} as Config
